<template>
	<div>
		<div class="operation_box">
			<div class="operation_item">
				<el-dropdown
					split-button type="primary"
					@click="showDebtorDetails"
					@command="(command) => command()"
				>
					<i class="fa fa-search-plus"></i>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item :command="showDebtorDetails">
							<i class="fa fa-search-plus"></i> {{ $t('debtorManagement.overview.debtorInformation') }}
						</el-dropdown-item>
						<el-dropdown-item :command="showDebtorContacts">
							<i class="fa fa-address-card"></i> {{ $t('debtorManagement.overview.debtorContact') }}
						</el-dropdown-item>
						<el-dropdown-item :command="showCreditManagement">
							<i class="fa fa-list"></i> {{ $t('debtorManagement.overview.creditManagement') }}
						</el-dropdown-item>
						<el-dropdown-item :command="showDebtorDocuments">
							<i class="fa fa-upload"></i> {{ $t('debtorManagement.overview.uploadDocument') }}
						</el-dropdown-item>
						<el-dropdown-item :command="requestPutOption" v-if="isAddPutOptionAllowed">
							<i class="fa fa-retweet"></i> {{ $t('debtorManagement.overview.requestPutOption') }}
						</el-dropdown-item>
						<el-dropdown-item :command="inviteDebtor" v-if="isInvitationAllowed">
							<i class="fa fa-envelope"></i> {{ $t('debtorManagement.overview.inviteDebtor') }}
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
		</div>
	</div>
</template>

<script>
import {enumDef} from "@/common/enumDefs";
import {debtorManagementApi} from "@/common/api/debtorManagementApi";
import {navigationTabs} from "@/common/navigation/navigationTabs";
import {navigationPaths} from "@/common/navigation/navigationPaths";
import {navigationUtils} from "@/common/navigation/navigationUtils";

export default {
	methods: {
		showDebtorDetails() {
			this.params.showDebtorDetails(this.params.data);
		},
		showDebtorContacts() {
			this.params.showDebtorContacts(this.params.data);
		},
		showCreditManagement() {
			this.params.showCreditManagement(this.params.data);
		},
		showDebtorDocuments() {
			this.params.showDebtorDocuments(this.params.data);
		},
		requestPutOption() {
			this.$router.push(navigationUtils.getRouteWithActiveTab(navigationPaths.seller.putOptions, navigationTabs.seller.putOptions.requests));
		},
		inviteDebtor() {
			let debtorId = this.params.data.debtorId;
			let name = this.$t("debtorManagement.overview.inviteDebtor.nameMissingWarning");
			let senderName = '';
			let receipt = '';
			let subject = encodeURIComponent(this.$t("debtorManagement.overview.inviteDebtor.subject"));
			let registrationLink = 'https://marketplace.walbing.com/' + 'vue/#/register'

			debtorManagementApi.inspection.getDebtorInvitationMailParams(debtorId)
				.then(res => {
					if (res.contact) {
						name = res.contact.name;
						receipt = res.contact.email;
					}
					senderName = res.senderName;
				}).
				finally(() => {
				let params = { name: name, senderName:  senderName, registrationLink: registrationLink};
				let body = encodeURIComponent(this.$t('debtorManagement.overview.inviteDebtor.body', params))
					window.location.href = 'mailto:' + receipt + '?subject=' + subject + '&body=' + body;
				})
		}
	},
	computed: {
		isInvitationAllowed() {
			return this.params.data.debtorType === enumDef.companyType.DebtorCompany;
		},
		isAddPutOptionAllowed() {
			return false;
			// https://walbing-jira.atlassian.net/browse/DEV-5659
			// let debtorState = this.params.data.debtorState
			// return debtorState === enumDef.debtorState.Verified || debtorState === enumDef.debtorState.Registered
		}
	}
};
</script>